import { jsxs as i, jsx as n } from "react/jsx-runtime";
import { clsx as s } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import o from "./roche-two-column-layout.module.scss.js";
import { RocheUITwoColumnLayoutVerticalAlignment as c, RocheUITwoColumnLayoutHorizontalAlignment as l } from "./roche-two-column-layout.type.js";
const C = ({
  horizontalAlignment: t = l.LEFT,
  verticalAlignment: m = c.CENTER,
  leftColumn: a,
  rightColumn: e
}) => {
  const r = s(
    o["two-column-layout"],
    m === c.TOP && o["two-column-layout--top"],
    m === c.BOTTOM && o["two-column-layout--bottom"]
  ), u = s(
    o["two-column-layout__column"],
    t === l.RIGHT && o["two-column-layout__column--right"],
    t === l.CENTER && o["two-column-layout__column--center"],
    t === l.FILL && o["two-column-layout__column--fill"]
  );
  return /* @__PURE__ */ i("div", { className: r, children: [
    /* @__PURE__ */ n("div", { className: u, children: a }),
    /* @__PURE__ */ n("div", { className: u, children: e })
  ] });
};
export {
  C as RocheUITwoColumnLayout
};
